// GA4 Script Loading Helper
export const loadGA4Script = (trackingId, setIsGA4Loaded) => {
  // Check if script already exists
  if (document.querySelector(`script[src*="${trackingId}"]`)) {
    setIsGA4Loaded(true);
    return;
  }

  // Load GA4 script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script1);

  // Initialize GA4
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${trackingId}', {
      page_title: document.title,
      page_location: window.location.href
    });
  `;
  document.head.appendChild(script2);

  script1.onload = () => setIsGA4Loaded(true);
};
